import type { CoreSelectionListItem } from 'src/core/CoreSelectionList/types'

/**
 * Значение поля `itemText` у пункта.
 * @example getTextValue({ name: 'Казань' }, 'name') // 'Казань'
 */
export default function getTextValue(
  item: CoreSelectionListItem,
  itemText: string,
): string {
  const text = item[itemText]

  return typeof text === 'string' ? text : String(text ?? '')
}
